import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import { Grid } from 'react-bootstrap';
import CityNav from '../cities/top-nav';
import {
  getLatestDwellings,
  dwellingsIsLoaded
} from '../redux/modules/dwellings';
import DwellingsList from './dwellings-list';
import CitiesList from '../cities/list';
import i18n from 'kodyl-js/i18n/react';

@connect(({ cities, dwellings: { meta, data, firstView, loading } }) => ({
  cities: cities.list,
  meta,
  dwellings: { data, firstView, loading }
}))
@i18n
class Frontpage extends Component {
  static fetchData({ getState, dispatch, reload }) {
    if (reload || !dwellingsIsLoaded(getState(), '/latest')) {
      const promise = dispatch(getLatestDwellings({ reload }));
      return __CLIENT__ ? null : promise;
    }
  }

  // static fetchDataDeferred({ getState, dispatch, reload }) {
  //   if (reload || !dwellingsIsLoaded(getState(), '/latest')) {
  //     return dispatch(getLatestDwellings());
  //   }
  // }

  render() {
    const {
      cities,
      meta: { limit = 15, results = 'ca. 3000' },
      dwellings
    } = this.props;
    const docMeta = {
      title: this.i18n(
        'Find din nye lejebolig på Boligninja.dk - vælg mellem %s ledige',
        results
      ),
      description: this.i18n(
        'Boligninja.dk er Danmarks nyeste boligportal, hvor du finder %s ledige lejligheder og huse til leje. Find din nye lejebolig eller lejelejlighed her.',
        results
      ),
      extend: true,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta}>
        <div className="content">
          <CityNav />
          <Grid className="listings-container">
            <DwellingsList
              frontpage
              headline={this.i18n('Latest %s of %s dwellings', limit, results)}
              {...dwellings}
              totalResults={results}
            />
          </Grid>

          <Grid>
            <hr />
            <h4>{this.i18n('Where do you want to live?')}</h4>
            <CitiesList onlyActive cities={cities} />
          </Grid>
        </div>
      </DocumentMeta>
    );
  }
}

export default Frontpage;
